import DialogController from './dialog/dialog.controller';

const dialogTemplate = require('./dialog/dialog.html');

/** @ngInject */
export default function folderPathEditDirectiveConfig(DialogService) {
    function link($scope, $element) {
        function showDialog(event) {
            DialogService.show({
                controller: DialogController,
                controllerAs: '$ctrl',
                template: dialogTemplate,
                parent: document.body,
                targetEvent: event,
                openFrom: 'top',
                closeTo: 'top',
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    folderChangedCallback: $scope.dtFolderPathEditCallback,
                    folderId: $scope.dtFolderPathEdit
                }
            });
        }

        $element.on('click', showDialog);

        $element.on('$destroy', () => {
            $element.off('click', showDialog);
        });
    }

    return {
        restrict: 'A',
        scope: {
            dtFolderPathEdit: '<',
            dtFolderPathEditCallback: '&'
        },
        link
    };
}



// WEBPACK FOOTER //
// ./app/common/folder-path-edit/folder-path-edit.directive.js